import React, { Component } from 'react';

import ProductDetails from '../components/AboutUs';
import AboutSection from '../components/AboutUs/AboutUs6';
import ContactSection from '../components/Contact';
import DownloadSection from '../components/Download';
import DetailSection from '../components/Features';
import FeatureSection from '../components/Features/Feature6';
import FooterSection from '../components/Footer';
import Header from '../components/Header/header';
import HeroSection from '../components/HeroSection/HeroSection6';
import PricingSection from '../components/Pricing';
import PromoSection from '../components/PromoSection';
import Screenshots from '../components/Screenshots';
import TeamMember from '../components/TeamMember';

const HEADER_OPTIONS = [
  {
    name: 'Vende Online',
    href: '#about',
    visible: true
  },
  {
    name: 'Controla tu Negocio',
    href: '#features',
    visible: true
  },
  {
    name: 'App',
    href: '#screenshots',
    visible: true
  },
  {
    name: 'Aliados',
    href: '#marcas',
    visible: true
  },
  {
    name: 'Planes',
    href: '#pricing',
    visible: true
  },
  {
    name: 'Equipo',
    href: '#team',
    visible: true
  }
];

class Theme extends Component {
  render() {
    return (
      <React.Fragment>
        <Header options={HEADER_OPTIONS}/>
        <div className="main">
          <HeroSection />
          <PromoSection />
          <AboutSection />
          <FeatureSection />
          <ProductDetails/>
          <DetailSection />
          <Screenshots />
          <DownloadSection />
          {/* <TrustedCompany /> */}
          {/* <Testimonial /> */}
          <PricingSection hideFaq={false} faq="four" bgColor="gray" />
          <TeamMember />
          <ContactSection />
        </div>
        <FooterSection />
      </React.Fragment>
    );
  }
}

export default Theme;
